/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PubListConfig,
} from '../models/index';
import {
    PubListConfigFromJSON,
    PubListConfigToJSON,
} from '../models/index';

export interface DeletePublicationListRequest {
    apiKey: string;
}

export interface DeletePublicationListsRequest {
    apiKeys: Array<string>;
}

export interface GetPublicationListRequest {
    apiKey: string;
}

export interface GetSingleEntryRequest {
    workId: number;
    style?: string;
    locale?: string;
}

export interface PreviewRequest {
    pubListConfig: PubListConfig;
}

export interface StoreRequest {
    apiKey: string;
    pubListConfig: PubListConfig;
}

export interface StoreNewRequest {
    pubListConfig: PubListConfig;
}

/**
 * 
 */
export class PublistListApi extends runtime.BaseAPI {

    /**
     * Creates request options for deletePublicationList without sending the request
     */
    async deletePublicationListRequestOpts(requestParameters: DeletePublicationListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['apiKey'] == null) {
            throw new runtime.RequiredError(
                'apiKey',
                'Required parameter "apiKey" was null or undefined when calling deletePublicationList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/list/{apiKey}`;
        urlPath = urlPath.replace(`{${"apiKey"}}`, encodeURIComponent(String(requestParameters['apiKey'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deletePublicationListRaw(requestParameters: DeletePublicationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deletePublicationListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePublicationList(requestParameters: DeletePublicationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePublicationListRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deletePublicationLists without sending the request
     */
    async deletePublicationListsRequestOpts(requestParameters: DeletePublicationListsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['apiKeys'] == null) {
            throw new runtime.RequiredError(
                'apiKeys',
                'Required parameter "apiKeys" was null or undefined when calling deletePublicationLists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/list/bulk/{apiKeys}`;
        urlPath = urlPath.replace(`{${"apiKeys"}}`, encodeURIComponent(String(requestParameters['apiKeys'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deletePublicationListsRaw(requestParameters: DeletePublicationListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<string>; }>> {
        const requestOptions = await this.deletePublicationListsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async deletePublicationLists(requestParameters: DeletePublicationListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<string>; }> {
        const response = await this.deletePublicationListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPublicationList without sending the request
     */
    async getPublicationListRequestOpts(requestParameters: GetPublicationListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['apiKey'] == null) {
            throw new runtime.RequiredError(
                'apiKey',
                'Required parameter "apiKey" was null or undefined when calling getPublicationList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/list/{apiKey}`;
        urlPath = urlPath.replace(`{${"apiKey"}}`, encodeURIComponent(String(requestParameters['apiKey'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPublicationListRaw(requestParameters: GetPublicationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getPublicationListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getPublicationList(requestParameters: GetPublicationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getPublicationListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSingleEntry without sending the request
     */
    async getSingleEntryRequestOpts(requestParameters: GetSingleEntryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['workId'] == null) {
            throw new runtime.RequiredError(
                'workId',
                'Required parameter "workId" was null or undefined when calling getSingleEntry().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['style'] != null) {
            queryParameters['style'] = requestParameters['style'];
        }

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/list/single/{workId}`;
        urlPath = urlPath.replace(`{${"workId"}}`, encodeURIComponent(String(requestParameters['workId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSingleEntryRaw(requestParameters: GetSingleEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getSingleEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getSingleEntry(requestParameters: GetSingleEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getSingleEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preview without sending the request
     */
    async previewRequestOpts(requestParameters: PreviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pubListConfig'] == null) {
            throw new runtime.RequiredError(
                'pubListConfig',
                'Required parameter "pubListConfig" was null or undefined when calling preview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/list/preview`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PubListConfigToJSON(requestParameters['pubListConfig']),
        };
    }

    /**
     */
    async previewRaw(requestParameters: PreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.previewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async preview(requestParameters: PreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.previewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for store without sending the request
     */
    async storeRequestOpts(requestParameters: StoreRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['apiKey'] == null) {
            throw new runtime.RequiredError(
                'apiKey',
                'Required parameter "apiKey" was null or undefined when calling store().'
            );
        }

        if (requestParameters['pubListConfig'] == null) {
            throw new runtime.RequiredError(
                'pubListConfig',
                'Required parameter "pubListConfig" was null or undefined when calling store().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/list/store/{apiKey}`;
        urlPath = urlPath.replace(`{${"apiKey"}}`, encodeURIComponent(String(requestParameters['apiKey'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PubListConfigToJSON(requestParameters['pubListConfig']),
        };
    }

    /**
     */
    async storeRaw(requestParameters: StoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.storeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async store(requestParameters: StoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.storeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for storeNew without sending the request
     */
    async storeNewRequestOpts(requestParameters: StoreNewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pubListConfig'] == null) {
            throw new runtime.RequiredError(
                'pubListConfig',
                'Required parameter "pubListConfig" was null or undefined when calling storeNew().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/list/store`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PubListConfigToJSON(requestParameters['pubListConfig']),
        };
    }

    /**
     */
    async storeNewRaw(requestParameters: StoreNewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.storeNewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async storeNew(requestParameters: StoreNewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.storeNewRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
